import { Card } from 'antd';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
}

const AuthLayout = ({ children, title, subtitle }: AuthLayoutProps) => {
  return (
    <div
      className="min-h-screen flex bg-cover bg-center bg-no-repeat w-screen h-screen"
      style={{
        backgroundImage: `url("/hero-image.png")`,
        backgroundSize: 'contain',
      }}
    >
      <div className="flex-1 flex flex-col">
        <div className="p-6 flex-1 flex flex-col justify-end items-center">
          <div className="w-full max-w-md">
            <Card className="shadow-md w-full">
              <div className="flex flex-col items-center text-center">
                <img
                  src="https://www.pgpfirst.com/wp-content/uploads/2023/08/logo.svg"
                  alt="Logo"
                  className="w-20 h-20 object-contain"
                />
                <h1 className="font-heading text-3xl font-bold mt-6 text-[#222222]">{title}</h1>
                <p className="font-heading text-[#222222] mt-2">{subtitle}</p>
              </div>
              {children}
            </Card>
          </div>
        </div>

        <div className="p-4 text-center text-[#222222] text-sm">
          © {new Date().getFullYear()} Innovate-Labs. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
